import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonPage,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
} from '@ionic/react';

const SkeletonPage = () => {
  return (
    <IonPage>
      <IonHeader className="primary-header">
        <IonToolbar className="primary-toolbar">
          <IonTitle>
            <IonSkeletonText animated style={{ width: '100%' }} />
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard style={{ height: '100%', paddingTop: '40px' }}>
          <IonCardHeader>
            <IonCardTitle>
              <IonSkeletonText animated style={{ width: '60%' }} />
            </IonCardTitle>
            <IonCardSubtitle>
              <IonSkeletonText animated style={{ width: '80%' }} />
            </IonCardSubtitle>
          </IonCardHeader>
          <IonCardContent>
            <IonSkeletonText animated style={{ width: '100%' }} />
            <IonSkeletonText animated style={{ width: '60%' }} />
            <IonSkeletonText animated style={{ width: '80%' }} />
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export { SkeletonPage };
